import { ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { SmartTireService } from 'src/app/services/feature/smartTire/smart-tire.service';

@Component({
    selector: 'app-smarttire-fleet-info',
    templateUrl: './smarttire-fleet-info.component.html',
    styleUrl: './smarttire-fleet-info.component.scss',
    standalone: false
})
export class SmarttireFleetInfoComponent {
 private destroy$ = new Subject<void>();
  constructor(private SmartTireService:SmartTireService,private cdr:ChangeDetectorRef){}

  ngOnInit() {
    this.SmartTireService.fleetInfoData$.pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      if(data!=null){
        this.fleetInfoForm.patchValue({
          numOfVechicles: data.numOfVechicles || 100,
          avgVechicles: data.avgVechicles || 75000,
          tierPerVechicles: data.tierPerVechicles || 8,
          tireInspection: data.tireInspection || 2,
          avgUnderInflation: data.avgUnderInflation || 15,
          tireLife: data.tireLife || 125000,
          downtimeInstance: data.downtimeInstance || 1,
          downtimeInstanceForVechicles: data.downtimeInstanceForVechicles || 2,
          fuelConsumption: data.fuelConsumption || 7.35
        });
      }
   
    })
    
  }

  fleetInfoForm = new FormGroup({
    numOfVechicles: new FormControl(100, { validators: [Validators.required, this.customValidator(1, 1000000)] }),
    avgVechicles: new FormControl(75000, { validators: [Validators.required, this.customValidator(1, 100000)] }),
    tierPerVechicles: new FormControl(8, { validators: [Validators.required, this.customValidator(2, 30)] }),
    tireInspection: new FormControl(2, { validators: [Validators.required, this.customValidator(1, 30)] }),
    avgUnderInflation: new FormControl(15, { validators: [Validators.required, this.customValidator(1, 30)] }),
    tireLife: new FormControl(12500, { validators: [Validators.required, this.customValidator(1, 300000)] }),
    downtimeInstance: new FormControl(1, { validators: [Validators.required, this.customValidator(1, 30)] }),
    downtimeInstanceForVechicles: new FormControl(2, { validators: [Validators.required, this.customValidator(1, 30)] }),
    fuelConsumption: new FormControl(7.35, { validators: [Validators.required, this.customValidator(1, 100)] }), 
  });


   customValidator(min: number, max: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
  
      // Convert value to string if it's not already a string
      const stringValue = value != null ? String(value) : '';
  
      // Check if the value is not present, is not a number, or is out of the specified range
      if (!value || isNaN(value) || value < min || value > max || stringValue.includes(',') || stringValue.includes('-')) {
        return { customValidation: true };
      }
  
      // If all checks pass, return null indicating no validation errors
      return null;
    };
  }
  get form() {
    return this.fleetInfoForm.controls;
  }
  endaSureNxt(){    
    if(this.fleetInfoForm.valid){
      this.SmartTireService.fleetInfoData$.next(this.fleetInfoForm.value);
     this.SmartTireService.currentComponent$.next('maintaince'); 
    
    //this.SmartTireService.TableCalculation();       
    }
    else{
      this.fleetInfoForm.markAllAsTouched();
    }  
    this.cdr.detectChanges();   
  }
  endaSureBack(){
    if(this.fleetInfoForm.valid){
      this.SmartTireService.currentComponent$.next('visitorInfo'); 
    }
    else{
      this.fleetInfoForm.markAllAsTouched();
    }   
    this.cdr.detectChanges();    
  }


  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
